<style>
.ql-bubble .ql-tooltip {
  background-color: #444;
  position: fixed;
  border-radius: 25px;
  color: #fff;
  display: fix;
  z-index: 99999999 !important;
}
.ql-editor {
  overflow-y: hidden;
}
</style>
<template>
<v-container fluid grid-list-xl>
    <v-layout wrap align-center>
      <v-flex xs12 sm12 d-flex>
        <v-select
          :items="items"
          label="Public"
        ></v-select>
      </v-flex>
      <v-flex xs12 d-flex>
         <v-text-field
            label="Well Name"
          ></v-text-field>
      </v-flex>
      <v-flex xs6 d-flex>
         <v-text-field
            label="Min"
          ></v-text-field>
      </v-flex>
      <v-flex xs6 d-flex>
         <v-text-field
            label="Max"
          ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 d-flex>
        <v-select
          :items="months"
          label="First Water Production (Months):"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 d-flex>
        <v-select
          :items="months"
          label="First Oil Production (Months):"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 d-flex>
        <v-select
          :items="months"
          label="Last Oil Production (Months):"
        ></v-select>
      </v-flex>
      <v-flex xs12 lg6>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              label="Date"
              hint="MM/DD/YYYY format"
              persistent-hint
              prepend-icon="event"
              @blur="date = parseDate(dateFormatted)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs12 lg6>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="computedDateFormatted"
              label="Date (read only text field)"
              hint="MM/DD/YYYY format"
              persistent-hint
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      
    </v-layout>
  </v-container>
</template>
<script>

export default {
  props: ["well-filter-chart"],
  data: vm => ({
     items: ['Watch Wells', 'Public'],
      months: [3, 6, 12, 36, 60],
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false
    }),
  components: {
  },
  computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      }
    },

    watch: {
      date () {
        this.dateFormatted = this.formatDate(this.date)
      }
    },

    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }
    },
  mounted: function() {
    //  console.log('this is current quill instance object', this.myQuillEditor);
  },
  beforeDestroy() {}
};
</script>
